<template>
    <div v-if="isMounted && items" ref="selector"  >
        <!-- SLIDER -->
        <div id="sliderObject" class="slider-object" >
            <!-- <div style="text-align: center; margin-top: -11px; white-space: nowrap; overflow: hidden; padding-left: 40px; margin-right: 50px;">
                <span style="font-size: 24px; color: #9198aa" :style="[item.id == currentItem.id ? {color: '#1997c6', 'text-shadow': '0px 0px 2px'}: '']" class="icon icon-dot-single" v-for="(item) in items" :key="item.id"></span>
            </div> -->
            <carousel-3d
            :startIndex="getStartIndex()"
            :controls-prev-html="'&#10092;'" :controls-next-html="'&#10093;'"
            :clickable="true"
            ref="slider"
            :key="sliderRefresh"
            :display="3">
                <slide
                    :key="item.id" v-for="(item, indxx) in items"
                    style="padding-top: 4%; padding-bottom: 4%;background-size: contain; border: none; border-radius: 6px; background-color: white;"
                    ref="slides" 
                    class="slide " 
                    :class="{'ischosen ':item.chosen, 'notchosen': !item.chosen || item.chosen == false || item.chosen == 'false'}" 
                    :index="indxx" 
                    :style='[{backgroundImage: "url(" + getMainImgUrl(item.imgUrl) + ")"}]'
                    >
                    <span v-if="item.chosen" :class="{'show-enlarge': item.chosen}" class="icon enlarge" @click="enlarge(item)"><img alt="expand" src="../../assets/img/enlarge.png"></span>
                    <div class="selector">
                        <div v-if="!item.chosen" class="banner-click">
                            <div class="banner-click-bg"></div>
                        </div>
                    </div>
                </slide>
            </carousel-3d>
            {{loadSlides()}}
                    <!-- DESCRIPTION -->
            <div style="padding-top: 5px;" v-if="this.currentItem.chosen==true" class="short-descr">
            
                <h2 class="big-title">{{this.currentItem.type!=='cpu' ? this.currentItem.brand +' '+ this.currentItem.model : this.currentItem.model}}</h2>
                
                <div class="descr">
                    <div class="best-for" v-for="(compat, key, index) in getListBullets(currentItem)" :key="index">
                        <span style=" display:block; min-width: 80px;" class="small-bullet value">
                            {{
                                key == 'Cache Memory' 
                                ? parseInt(compat) + ' MB' 
                                : (key == 'Capacity' || key == 'Max RAM') 
                                ? parseInt(compat) + ' GB' 
                                : (key == 'RAM Speed' || key == 'Memory Clock') 
                                ? parseInt(compat)+' MHz' 
                                : (key == 'TDP' || key == 'Wattage') 
                                ? parseInt(compat) + ' W'
                                : compat
                            }}</span>
                        <span class="small-bullet key">{{key}} </span>
                    </div>
                    <div class="slider-bullets" style="margin-top: 20px;">
                        <ul style="list-style-type: none !important;" v-for="(bullet, index) in JSON.parse(currentItem.bullets)" :key="index" class="bullets">
                            <li>{{bullet}}</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <!-- SPEEDOMETER & COMPAT TABLE -->
        <div class="speedometer-div">
            <div style="position: absolute;margin-top: -6px; padding-left: 8px;">
                <span style="color: #9198aa" class="icon icon-info-with-circle"></span>
            </div>
            <!-- SPEEDOMETER -->
            <vue-speedometer v-if="this.currentItem.chosen==true && this.currentItem.type == 'cpu' || this.currentItem.type == 'gpu' || this.currentItem.type == 'graphics'"   class="speedometer"
                :height="145"
                :width="220"
                :needleHeightRatio="0.6"
                valueTextFontSize="16px"
                :value="perf < 100 ? perf : 100"
                :maxValue="101"
                :segments="3"
                currentValueText="Performance "
                :segmentColors='["#c7254e", "#e1d420", "#18b37e" ]'
                :ringWidth="4"
                :needleTransitionDuration="1000"
                needleTransition="easeQuadInOut"
                needleColor="#cfd2da"
                textColor="#1997c6"
                :fontWeight="'600'"
                :customSegmentLabels='[
                    {
                        text: "Slow",
                        position: "OUTSIDE",
                        color: "#9198aa",
                    },
                    {
                        text: " ",
                        position: "OUTSIDE",
                        color: "#9198aa",
                    },
                    {
                        text: "Fast",
                        position: "OUTSIDE",
                        color: "#9198aa",
                    },
                ]'
            />
            <!-- COMPATS -->
            <div style="min-width: " v-if="this.currentItem.chosen==true" class="infographics">
        <!-- CPU INFO -->
                <!-- FREQUENCY -->
                <div style="min-width: 85px !important" v-if="this.currentItem.chosen==true && this.currentItem.type == 'cpu'" class="best-for" >
                    <span style="display:block; min-width: 80px;" class="small-bullet value">{{parseFloat(this.currentItem.specs.Core_Frequency)+ ' GHz'}}</span>
                    <span class="small-bullet key">Frequency</span>
                </div>
                <!-- CORES -->
                <div style="min-width: 64px !important" v-if="this.currentItem.chosen==true && this.currentItem.type == 'cpu'" class="best-for" >
                    <span style=" display:block; " class="small-bullet value">{{this.currentItem.specs.Number_of_Cores}}</span>
                    <span class="small-bullet key">Cores</span>
                </div>
                <!-- THREADS -->
                <div style="min-width: 64px !important" v-if="this.currentItem.chosen==true && this.currentItem.type == 'cpu'" class="best-for" >
                    <span style=" display:block;" class="small-bullet value">{{this.currentItem.specs.Number_of_Threads}}</span>
                    <span class="small-bullet key">Threads</span>
                </div>
                <!-- SOCKET -->
                <div style="" v-if="this.currentItem.chosen==true && this.currentItem.type == 'cpu'" class="best-for" >
                    <div v-if="allMenuOptions && allMenuOptions.motherboard.item.contents" class="call">{{getCompatibility({item: this.currentItem, withType: 'motherboard', option: 'socket'})}}</div> 
                    <span style="display:block;" 
                    :class="{
                        incompatible: checkCompatTable('motherboard', 'socket', allMenuOptions, this.currentItem, getCompatTable) == false,
                        compatible: checkCompatTable('motherboard', 'socket', allMenuOptions, this.currentItem, getCompatTable) == true
                    }" 
                    class="small-bullet value">{{this.currentItem.compat.socket}}</span>
                    <span class="small-bullet key">Socket</span>
                </div>
                <!-- MAX RAM -->
                <div style="" v-if="this.currentItem.chosen==true && this.currentItem.type == 'cpu'" class="best-for" >
                    <div  v-if="allMenuOptions && allMenuOptions.ram.item.contents"  class="call">{{getCompatibility({item: this.currentItem, withType: 'ram', option: 'max_memory'})}}</div>
                    <span :class="{
                        incompatible: 
                                checkCompatTable('ram', 'max_memory', allMenuOptions, this.currentItem, getCompatTable) == false,
                        compatible: 
                                checkCompatTable('ram', 'max_memory', allMenuOptions, this.currentItem, getCompatTable) == true
                    }"  
                    style="display:block;" 
                    class="small-bullet value">
                        {{allMenuOptions.ram.item.contents ? parseInt(getItemValue({item: allMenuOptions.ram.item.contents, field: 'capacity'}))+'/':""}}{{parseInt(this.currentItem.specs.Max_Memory_Size) + ' GB'}}
                    </span>
                    <span class="small-bullet key">Max Memory</span>
                </div>
                <!-- MEMORY SPEED -->
                <div v-if="this.currentItem.chosen==true && (this.currentItem.type == 'cpu')" class="best-for" >
                    <div v-if="allMenuOptions && allMenuOptions.motherboard.item.contents"  class="call">{{getCompatibility({item: this.currentItem, withType: 'motherboard', option: 'ram_speed'})}}</div> 
                    <div v-if="allMenuOptions && allMenuOptions.ram.item.contents"  class="call">{{getCompatibility({item: this.currentItem, withType: 'ram', option: 'ram_speed'})}}</div> 
                    <span
                     :class="{
                        incompatible: checkCompatTable('motherboard', 'ram_speed', allMenuOptions, this.currentItem, getCompatTable) == false || checkCompatTable('ram', 'ram_speed', allMenuOptions, this.currentItem, getCompatTable) == false,
                        compatible:   checkCompatTable('motherboard', 'ram_speed', allMenuOptions, this.currentItem, getCompatTable) == true || checkCompatTable('ram', 'ram_speed', allMenuOptions, this.currentItem, getCompatTable) == true,
                        warn:   checkCompatTable('motherboard', 'ram_speed', allMenuOptions, this.currentItem, getCompatTable) == 'warning' || checkCompatTable('ram', 'ram_speed', allMenuOptions, this.currentItem, getCompatTable) == 'warning'
                    }" 
                     style=" display:block;" 
                     class="small-bullet value">{{parseInt(this.currentItem.compat.ram_speed)}} MHz</span>
                    <span class="small-bullet key">Memory Speed</span>
                </div>
                <!-- MEMORY TYPE-->
                <div v-if="this.currentItem.chosen==true && this.currentItem.type == 'cpu'" class="best-for" >
                    <div  v-if="allMenuOptions && allMenuOptions.motherboard.item.contents"  class="call">{{getCompatibility({item: this.currentItem, withType: 'motherboard', option: 'ram_type'})}}</div> 
                    <div  v-if="allMenuOptions && allMenuOptions.ram.item.contents"  class="call">{{getCompatibility({item: this.currentItem, withType: 'ram', option: 'ram_type'})}}</div> 
                    <span
                    :class="{
                        incompatible: 
                            checkCompatTable('motherboard', 'ram_type', allMenuOptions, this.currentItem, getCompatTable) == false
                        ||  checkCompatTable('ram', 'ram_type', allMenuOptions, this.currentItem, getCompatTable) == false,
                        compatible: 
                            checkCompatTable('motherboard', 'ram_type', allMenuOptions, this.currentItem, getCompatTable) == true
                        ||  checkCompatTable('ram', 'ram_type', allMenuOptions, this.currentItem, getCompatTable) == true,
                    }" 
                    style=" display:block;" 
                    class="small-bullet value">{{this.currentItem.compat.ram}}</span>
                    <span class="small-bullet key">Memory Type</span>
                </div>
        <!-- MB INFO -->
                <h4 v-if="this.currentItem.chosen==true && this.currentItem.type !== 'cpu' && this.currentItem.type !== 'graphics' && this.currentItem.type !== 'gpu'" >Compatibility</h4>
                <!-- SOCKET -->
                <div v-if="this.currentItem.chosen==true && this.currentItem.type == 'motherboard'" class="best-for" >
                    <div v-if="allMenuOptions && allMenuOptions.cpu.item.contents" class="call">{{getCompatibility({item: this.currentItem, withType: 'cpu', option: 'socket'})}}</div> 
                    <span
                    :class="{
                        incompatible: checkCompatTable('cpu', 'socket', allMenuOptions, this.currentItem, getCompatTable) == false,
                        compatible: checkCompatTable('cpu', 'socket', allMenuOptions, this.currentItem, getCompatTable) == true
                    }" 
                     style=" display:block;"
                     class="small-bullet value">{{this.currentItem.specs.Socket}}</span>
                    <span class="small-bullet key">Socket</span>
                </div>
                <!-- MEMORY TYPE-->
                <div v-if="this.currentItem.chosen==true && this.currentItem.type == 'motherboard'" class="best-for" >
                    <div  v-if="allMenuOptions && allMenuOptions.cpu.item.contents"  class="call">{{getCompatibility({item: this.currentItem, withType: 'cpu', option: 'ram_type'})}}</div> 
                    <div  v-if="allMenuOptions && allMenuOptions.ram.item.contents"  class="call">{{getCompatibility({item: this.currentItem, withType: 'ram', option: 'ram_type'})}}</div> 
                    <span
                    :class="{
                        incompatible: 
                            checkCompatTable('cpu', 'ram_type', allMenuOptions, this.currentItem, getCompatTable) == false
                        ||  checkCompatTable('ram', 'ram_type', allMenuOptions, this.currentItem, getCompatTable) == false,
                        compatible: 
                            checkCompatTable('cpu', 'ram_type', allMenuOptions, this.currentItem, getCompatTable) == true
                        ||  checkCompatTable('ram', 'ram_type', allMenuOptions, this.currentItem, getCompatTable) == true,
                    }" 
                    style=" display:block;" 
                    class="small-bullet value">{{this.currentItem.compat.ram}}</span>
                    <span class="small-bullet key">Memory Type</span>
                </div>
                <!-- MEMORY SPEED -->
                <div v-if="this.currentItem.chosen==true && (this.currentItem.type == 'motherboard')" class="best-for" >
                    <div  v-if="allMenuOptions && allMenuOptions.cpu.item.contents"  class="call">{{getCompatibility({item: this.currentItem, withType: 'cpu', option: 'ram_speed'})}}</div> 
                    <div  v-if="allMenuOptions && allMenuOptions.ram.item.contents"  class="call">{{getCompatibility({item: this.currentItem, withType: 'ram', option: 'ram_speed'})}}</div>
                    <span
                     :class="{
                        incompatible: 
                            checkCompatTable('cpu', 'ram_speed', allMenuOptions, this.currentItem, getCompatTable) == false,
                        compatible: 
                            checkCompatTable('cpu', 'ram_speed', allMenuOptions, this.currentItem, getCompatTable) == true
                        ||  checkCompatTable('ram', 'ram_speed', allMenuOptions, this.currentItem, getCompatTable) == true,
                        warn:
                            checkCompatTable('cpu', 'ram_speed', allMenuOptions, this.currentItem, getCompatTable) == 'warning' 
                        ||  checkCompatTable('ram', 'ram_speed', allMenuOptions, this.currentItem, getCompatTable) == 'warning'
                    }" 
                     style=" display:block;" 
                     class="small-bullet value">{{parseInt(this.currentItem.compat.ram_speed)}} MHz</span>
                    <span class="small-bullet key">Memory Speed</span>
                </div>
                <!-- MEMORY SLOTS -->
                <div v-if="this.currentItem.chosen==true && this.currentItem.type == 'motherboard'" class="best-for" >
                    <div  v-if="allMenuOptions && allMenuOptions.ram.item.contents"  class="call">{{getCompatibility({item: this.currentItem, withType: 'ram', option: 'number_of_items'})}}</div>
                    <span :class="{
                        incompatible: checkCompatTable('ram', 'number_of_items', allMenuOptions, this.currentItem, getCompatTable) == false,
                        compatible:   checkCompatTable('ram', 'number_of_items', allMenuOptions, this.currentItem, getCompatTable) == true
                    }"  
                    style=" display:block;" 
                    class="small-bullet value"><span v-if="allMenuOptions && allMenuOptions.ram.item.contents">{{parseInt(getItemValue({item: allMenuOptions.ram.item.contents, field: 'slots'})) }}/</span><span >{{this.currentItem.compat.ram_slots}}</span></span>
                    <span class="small-bullet key">Memory Slots</span>
                </div>
                <!-- MAX MEMORY -->
                <div v-if="this.currentItem.chosen==true && this.currentItem.type == 'motherboard'" class="best-for" >
                    <div  v-if="allMenuOptions && allMenuOptions.ram.item.contents"  class="call">{{getCompatibility({item: this.currentItem, withType: 'ram', option: 'max_memory'})}}</div>
                    <span :class="{
                        incompatible: 
                            checkCompatTable('cpu', 'max_memory', allMenuOptions, this.currentItem, getCompatTable) == false
                        ||  checkCompatTable('ram', 'max_memory', allMenuOptions, this.currentItem, getCompatTable) == false,
                        compatible: 
                            checkCompatTable('cpu', 'max_memory', allMenuOptions, this.currentItem, getCompatTable) == true
                        ||  checkCompatTable('ram', 'max_memory', allMenuOptions, this.currentItem, getCompatTable) == true,
                    }"  
                    style=" display:block;" 
                    class="small-bullet value">
                        {{allMenuOptions.ram.item.contents ? parseInt(getItemValue({item: allMenuOptions.ram.item.contents, field: 'capacity'}))+'/':""}}{{parseInt(this.currentItem.specs.Max_Memory_Size) + ' GB'}}
                    </span>
                    <span class="small-bullet key">Max Memory</span>
                </div>
                <!-- PROCESSOR GENERATION -->
                <div v-if="this.currentItem.chosen==true && this.currentItem.type == 'motherboard'" class="best-for" >
                     <div  v-if="allMenuOptions && allMenuOptions.cpu.item.contents"  class="call">{{getCompatibility({item: this.currentItem, withType: 'cpu', option: 'processor_generation'})}}</div>
                    <span :class="{
                        incompatible: checkCompatTable('cpu', 'processor_generation', allMenuOptions, this.currentItem, getCompatTable) == false,
                        compatible:   checkCompatTable('cpu', 'processor_generation', allMenuOptions, this.currentItem, getCompatTable) == true
                    }"  
                    style=" display:block;" 
                    class="small-bullet value">
                        {{parseInt(this.currentItem.compat.processor_generation)}}
                    </span>
                    <span class="small-bullet key">Processor Gen</span>
                </div>
                <!-- PCI-E -->
                <div v-if="this.currentItem.chosen==true && this.currentItem.type == 'motherboard'" class="best-for" >
                    <span style=" display:block;" class="small-bullet value">{{this.currentItem.compat.pci_e}}</span>
                    <span class="small-bullet key">PCI-Express</span>
                </div>
                <!-- FORM FACTOR -->
                <div v-if="this.currentItem.chosen==true && (this.currentItem.type == 'motherboard')" class="best-for" >
                    <div v-if="allMenuOptions"  class="call">{{getCompatibility({item: this.currentItem, withType: 'psu', option: 'form_factor'})}}</div>
                    <div v-if="allMenuOptions"  class="call">{{getCompatibility({item: this.currentItem, withType: 'case', option: 'form_factor'})}}</div>
                    <span :class="{
                        incompatible: 
                            checkCompatTable('psu',  'form_factor', allMenuOptions, this.currentItem, getCompatTable) == false
                        ||  checkCompatTable('case', 'form_factor', allMenuOptions, this.currentItem, getCompatTable) == false,
                        compatible: 
                            checkCompatTable('psu',  'form_factor', allMenuOptions, this.currentItem, getCompatTable) == true
                        ||  checkCompatTable('case', 'form_factor', allMenuOptions, this.currentItem, getCompatTable) == true,
                        warn: 
                            checkCompatTable('psu',  'form_factor', allMenuOptions, this.currentItem, getCompatTable) == 'warning'
                        ||  checkCompatTable('case', 'form_factor', allMenuOptions, this.currentItem, getCompatTable) == 'warning',
                    }"  
                    style=" display:block;" 
                    class="small-bullet value">
                        <span v-if="allMenuOptions">{{this.currentItem.compat.form_factor}}</span>
                    </span>
                    <span class="small-bullet key">Form Factor</span>
                </div>
        <!-- RAM -->
                <!-- MEMORY TYPE -->
                <div v-if="this.currentItem.chosen==true && this.currentItem.type == 'ram'" class="best-for" >
                     <div  v-if="allMenuOptions && allMenuOptions.motherboard.item.contents"  class="call">{{getCompatibility({item: this.currentItem, withType: 'motherboard', option: 'ram_type'})}}</div> 
                     <div  v-if="allMenuOptions && allMenuOptions.cpu.item.contents" class="call">{{getCompatibility({item: this.currentItem, withType: 'cpu', option: 'ram_type'})}}</div> 
                    <span
                    :class="{
                        incompatible: 
                            checkCompatTable('cpu',         'ram_type', allMenuOptions, this.currentItem, getCompatTable) == false
                        ||  checkCompatTable('motherboard', 'ram_type', allMenuOptions, this.currentItem, getCompatTable) == false,
                        compatible: 
                            checkCompatTable('cpu',         'ram_type', allMenuOptions, this.currentItem, getCompatTable) == true
                        ||  checkCompatTable('motherboard', 'ram_type', allMenuOptions, this.currentItem, getCompatTable) == true,
                    }" 
                    style=" display:block;" 
                    class="small-bullet value">{{this.currentItem.compat.ram_type}}</span>
                    <span class="small-bullet key">Memory Type</span>
                </div>
                <!-- MEMORY SPEED -->
                <div v-if="this.currentItem.chosen==true && (this.currentItem.type == 'ram')" class="best-for" >
                    <div v-if="allMenuOptions && allMenuOptions.motherboard.item.contents"  class="call">{{getCompatibility({item: this.currentItem, withType: 'motherboard', option: 'ram_speed'})}}</div> 
                    <div v-if="allMenuOptions && allMenuOptions.cpu.item.contents"  class="call">{{getCompatibility({item: this.currentItem, withType: 'cpu', option: 'ram_speed'})}}</div> 
                    <span
                     :class="{
                        incompatible: checkCompatTable('motherboard', 'ram_speed', allMenuOptions, this.currentItem, getCompatTable) == false || checkCompatTable('cpu', 'ram_speed', allMenuOptions, this.currentItem, getCompatTable) == false,
                        compatible:   checkCompatTable('motherboard', 'ram_speed', allMenuOptions, this.currentItem, getCompatTable) == true || checkCompatTable('cpu', 'ram_speed', allMenuOptions, this.currentItem, getCompatTable) == true,
                        warn:         checkCompatTable('motherboard', 'ram_speed', allMenuOptions, this.currentItem, getCompatTable) == 'warning' || checkCompatTable('cpu', 'ram_speed', allMenuOptions, this.currentItem, getCompatTable) == 'warning'
                    }" 
                     style=" display:block;" 
                     class="small-bullet value">{{parseInt(this.currentItem.compat.ram_speed)}} MHz</span>
                    <span class="small-bullet key">Memory Speed</span>
                </div>
                <!-- MEMORY SLOTS -->
                <div v-if="this.currentItem.chosen==true && this.currentItem.type == 'ram'" class="best-for" >
                    <div  v-if="allMenuOptions && allMenuOptions.motherboard.item.contents"  class="call">{{getCompatibility({item: this.currentItem, withType: 'motherboard', option: 'ram_slots'})}}</div>
                    <span :class="{
                        incompatible: checkCompatTable('motherboard', 'ram_slots', allMenuOptions, this.currentItem, getCompatTable) == false,
                        compatible:   checkCompatTable('motherboard', 'ram_slots', allMenuOptions, this.currentItem, getCompatTable) == true
                    }"  
                    style=" display:block;" 
                    class="small-bullet value"><span>{{getItemValue({item: allMenuOptions.ram.item.contents, field: 'slots'}) || 0}}</span><span v-if="allMenuOptions && allMenuOptions.motherboard.item.contents">/{{parseInt(allMenuOptions.motherboard.item.contents.compat.ram_slots) }}</span></span>
                    <span class="small-bullet key">Memory Slots</span>
                </div>
                <!-- MAX-MEMORY -->
                <div v-if="this.currentItem.chosen==true && this.currentItem.type == 'ram'" class="best-for" >
                     <div  v-if="allMenuOptions && allMenuOptions.motherboard.item.contents"  class="call">{{getCompatibility({item: this.currentItem, withType: 'motherboard', option: 'max_memory'})}}</div>
                     <div  v-if="allMenuOptions && allMenuOptions.cpu.item.contents"  class="call">{{getCompatibility({item: this.currentItem, withType: 'cpu', option: 'max_memory'})}}</div>
                    <span :class="{
                        incompatible: 
                            checkCompatTable('cpu',         'max_memory', allMenuOptions, this.currentItem, getCompatTable) == false
                        ||  checkCompatTable('motherboard', 'max_memory', allMenuOptions, this.currentItem, getCompatTable) == false,
                        compatible: 
                            checkCompatTable('cpu',         'max_memory', allMenuOptions, this.currentItem, getCompatTable) == true
                        ||  checkCompatTable('motherboard', 'max_memory', allMenuOptions, this.currentItem, getCompatTable) == true,
                    }"  
                    style=" display:block;" 
                    class="small-bullet value">
                        {{this.currentItem.compat.copacity + allMenuOptions.ram.item.contents ? parseInt(getItemValue({item: allMenuOptions.ram.item.contents, field: 'capacity'})):0}}<span v-if="(!allMenuOptions.motherboard.item.contents && !allMenuOptions.cpu.item.contents)"> GB</span><span v-if="allMenuOptions.motherboard.item.contents || allMenuOptions.cpu.item.contents">/{{parseInt(getMaxMem({cpu: allMenuOptions.cpu.item.contents, mb: allMenuOptions.motherboard.item.contents})) + ' GB'}}</span>
                    </span>
                    <span class="small-bullet key">Total Memory</span>
                </div>
        <!-- STORAGE -->
                <!-- Interface -->
                <div v-if="this.currentItem.chosen==true && this.currentItem.type == 'storage'" class="best-for" >
                    <div  v-if="allMenuOptions && allMenuOptions.motherboard.item.contents"  class="call">{{getCompatibility({item: this.currentItem, withType: 'motherboard', option: 'interface'})}}</div>
                    <span :class="{
                        incompatible: checkCompatTable('motherboard', 'interface', allMenuOptions, this.currentItem, getCompatTable) == false,
                        compatible:   checkCompatTable('motherboard', 'interface', allMenuOptions, this.currentItem, getCompatTable) == true
                    }"  
                    style=" display:block;" 
                    class="small-bullet value">{{this.currentItem.compat.compat_interface}}</span>
                    <span class="small-bullet key">Interface</span>
                </div>
                <!-- SLOTS -->
                <div v-if="this.currentItem.chosen==true && this.currentItem.type == 'storage' && (allMenuOptions.storage.item.contents && currentItem.compat.compat_interface.toLowerCase().includes('sata') && allMenuOptions.storage.item.contents.length >0 && allMenuOptions.motherboard.item.contents)" class="best-for" >
                    <div  v-if="allMenuOptions && allMenuOptions.motherboard.item.contents"  class="call">{{getCompatibility({item: this.currentItem, withType: 'motherboard', option: 'sata_slots'})}}</div>
                    <span :class="{
                        incompatible: checkCompatTable('motherboard', 'sata_slots', allMenuOptions, this.currentItem, getCompatTable) == false,
                        compatible:   checkCompatTable('motherboard', 'sata_slots', allMenuOptions, this.currentItem, getCompatTable) == true
                    }"  
                    style=" display:block;" 
                    class="small-bullet value"><span>{{allMenuOptions.storage.item.contents.filter((item) => item.compat.compat_interface.toLowerCase().includes('sata')).length}}</span>/{{parseInt(allMenuOptions.motherboard.item.contents.compat.sata_slots)}}</span>
                    <span class="small-bullet key">Sata Slots</span>
                </div>
                <!-- M.2 -->
                <div v-if="this.currentItem.chosen==true && this.currentItem.type == 'storage' && (allMenuOptions.storage.item.contents && currentItem.compat.compat_interface.toLowerCase().includes('pci') && allMenuOptions.storage.item.contents.length >0 && allMenuOptions.motherboard.item.contents)" class="best-for" >
                    <div  v-if="allMenuOptions && allMenuOptions.motherboard.item.contents"  class="call">{{getCompatibility({item: this.currentItem, withType: 'motherboard', option: 'm.2_slots'})}}</div>
                    <span :class="{
                        incompatible: checkCompatTable('motherboard', 'm.2_slots', allMenuOptions, this.currentItem, getCompatTable) == false,
                        compatible:   checkCompatTable('motherboard', 'm.2_slots', allMenuOptions, this.currentItem, getCompatTable) == true
                    }"  
                    style=" display:block;" 
                    class="small-bullet value"><span>{{allMenuOptions.storage.item.contents.filter((item) => item.compat.size.toLowerCase().includes('m.2')).length}}</span>/{{parseInt(allMenuOptions.motherboard.item.contents.compat.M_2_Slot)}}</span>
                    <span class="small-bullet key">M.2 Slots</span>
                </div>
        <!-- GRAPHICS -->
                <!-- Core Clock -->
                <div style="min-width: 85px !important" v-if="this.currentItem.chosen==true && this.currentItem.type == 'graphics'" class="best-for" >
                    <span style=" display:block; min-width: 80px;" class="small-bullet value">{{parseInt(this.currentItem.specs.GPU_clock_speed)+' MHz'}}</span>
                    <span class="small-bullet key">Core Clock</span>
                </div>
                <!-- Ram Capacity -->
                <div style="min-width: 64px !important" v-if="this.currentItem.chosen==true && this.currentItem.type == 'graphics'" class="best-for" >
                    <span style=" display:block; " class="small-bullet value">{{parseInt(this.currentItem.specs.graphics_ram_capacity)+' GB'}}</span>
                    <span class="small-bullet key">RAM</span>
                </div>
                <!-- Bandwidth -->
                <div style="min-width: 64px !important" v-if="this.currentItem.chosen==true && this.currentItem.type == 'graphics'" class="best-for" >
                    <span style=" display:block;" class="small-bullet value">{{parseInt(this.currentItem.specs.memory_bus_width)+' bit'}}</span>
                    <span class="small-bullet key">Bus</span>
                </div>
                <!-- PCI_E_x16 SLOT -->
                <div v-if="this.currentItem.chosen==true && (this.currentItem.type == 'graphics' || this.currentItem.type == 'gpu')" class="best-for" >
                    <div  v-if="allMenuOptions"  class="call">{{getCompatibility({item: this.currentItem, withType: 'motherboard', option: 'pci_e_x16'})}}</div>
                    <span :class="{
                        incompatible: checkCompatTable('motherboard', 'pci_e_x16', allMenuOptions, this.currentItem, getCompatTable) == false,
                        compatible:   checkCompatTable('motherboard', 'pci_e_x16', allMenuOptions, this.currentItem, getCompatTable) == true
                    }"  
                    style=" display:block;" 
                    class="small-bullet value">
                        <span v-if="allMenuOptions.graphics.item.contents && allMenuOptions.graphics.item.contents.length >0">{{allMenuOptions.graphics.item.contents.length}}</span><span v-else>0</span>
                        <span v-if="allMenuOptions.motherboard.item.contents">/{{allMenuOptions.motherboard.item.contents.compat.pci_e_x16}}</span>
                    </span>
                    <span class="small-bullet key">PCI-E (x16) Slots</span>
                </div>
        <!-- PSU -->
                <!-- POWER -->
                <div v-if="this.currentItem.chosen==true && (this.currentItem.type == 'psu')" class="best-for" >
                    <div  v-if="allMenuOptions"  class="call">{{getCompatibility({item: this.currentItem, withType: 'general', option: 'power'})}}</div>
                    <span :class="{
                        incompatible: checkCompatTable('general', 'power', allMenuOptions, this.currentItem, getCompatTable) == false,
                        compatible:   checkCompatTable('general', 'power', allMenuOptions, this.currentItem, getCompatTable) == true
                        }"  
                        style=" display:block;" 
                        class="small-bullet value">
                        <span v-if="allMenuOptions">{{this.getBuildTDP}}/</span><span v-else>0</span>
                        <span v-if="allMenuOptions">{{parseInt(this.currentItem.specs.wattage)}} W</span>
                    </span>
                    <span class="small-bullet key">Power</span>
                </div>
                <!-- FORM FACTOR -->
                <div v-if="this.currentItem.chosen==true && (this.currentItem.type == 'psu')" class="best-for" >
                    <div v-if="allMenuOptions"  class="call">{{getCompatibility({item: this.currentItem, withType: 'motherboard', option: 'form_factor'})}}</div>
                    <div v-if="allMenuOptions"  class="call">{{getCompatibility({item: this.currentItem, withType: 'case', option: 'form_factor'})}}</div>
                    <span :class="{
                        incompatible: 
                            checkCompatTable('motherboard',         'form_factor', allMenuOptions, this.currentItem, getCompatTable) == false
                        ||  checkCompatTable('case',                'form_factor', allMenuOptions, this.currentItem, getCompatTable) == false,
                        compatible: 
                            checkCompatTable('motherboard',         'form_factor', allMenuOptions, this.currentItem, getCompatTable) == true
                        ||  checkCompatTable('case',                'form_factor', allMenuOptions, this.currentItem, getCompatTable) == true,
                    }"  
                    style=" display:block;" 
                    class="small-bullet value">
                        <span v-if="allMenuOptions">{{this.currentItem.compat.form_factor}}</span>
                    </span>
                    <span class="small-bullet key">Form Factor</span>
                </div>
        <!-- CASE -->
                <!-- FORM FACTOR -->
                <div v-if="this.currentItem.chosen==true && (this.currentItem.type == 'case')" class="best-for" >
                    <div v-if="allMenuOptions"  class="call">{{getCompatibility({item: this.currentItem, withType: 'motherboard', option: 'form_factor'})}}</div>
                    <div v-if="allMenuOptions"  class="call">{{getCompatibility({item: this.currentItem, withType: 'psu', option: 'form_factor'})}}</div>
                    <span :class="{
                        incompatible: 
                            checkCompatTable('motherboard',         'form_factor', allMenuOptions, this.currentItem, getCompatTable) == false
                        ||  checkCompatTable('psu',                 'form_factor', allMenuOptions, this.currentItem, getCompatTable) == false,
                        compatible: 
                            checkCompatTable('motherboard',         'form_factor', allMenuOptions, this.currentItem, getCompatTable) == true
                        ||  checkCompatTable('psu',                 'form_factor', allMenuOptions, this.currentItem, getCompatTable) == true,
                        warn: 
                            checkCompatTable('motherboard',         'form_factor', allMenuOptions, this.currentItem, getCompatTable) == 'warning'
                        ||  checkCompatTable('psu',                 'form_factor', allMenuOptions, this.currentItem, getCompatTable) == 'warning',
                    }"  
                    style=" display:block;" 
                    class="small-bullet value">
                        <span v-if="allMenuOptions">{{this.currentItem.compat.form_factor}}</span>
                    </span>
                    <span class="small-bullet key">Form Factor</span>
                </div>
            </div>
            <!-- BUTTONS -->
            <div style="margin-top: 70px;" v-if="currentItem !== ''" class="buttons">
                <div style="margin-bottom: 8px; padding-top: 5px;" class="price">
                    <h4 style="color: #9198aa !important; " class="dollar-sign">$</h4>
                    <!-- PRICE -->
                    <h2 style="" @click="startAnimate()" class="price-tag">
                        <animate-number
                        ref="animatedNumber"
                        :from="priceFrom" 
                        mode="auto"
                        :to="priceTo" 
                        duration="700" 
                        :formatter="formatter"
                    ></animate-number></h2>
                    <span v-if="this.cents(currentItem.amzn_price) !== '00' && this.cents(currentItem.amzn_price) < 10" style="color: #e4d836; margin-right: -2px; vertical-align: top;font-size: 20px;">0</span>
                    <animate-number
                        style="color: #e4d836;vertical-align: top;margin-left: 2px;font-size: 20px;"
                        ref="animatedNumberCents"
                        :from="10" 
                        mode="auto"
                        :to="this.cents(currentItem.amzn_price) || '00'" 
                        duration="700" 
                        :formatter="formatter"
                    ></animate-number>
                    <span v-if="this.cents(currentItem.amzn_price) == '00'" style="color: #e4d836;vertical-align: top;font-size: 20px;">0</span>
                </div>
                <button v-if="!ifAdded(this.currentItem)" style="width: 100%; margin-bottom: 5px;  padding-right: 25px;" @click="addToBuild(currentItem), addToMenu(currentItem), getPrice()" class="gc-button btn">
                    SELECT<span class="icon icon-check" ></span>
                </button>
                <!-- IF RAM || STORAGE || GPU -->
                <div v-if="ifAdded(this.currentItem) && (this.currentItem.type == 'ram' || this.currentItem.type == 'storage' || this.currentItem.type == 'gpu' || this.currentItem.type == 'graphics')"    >
                    <button v-if="ifAdded(this.currentItem)"  style="width: 80%; margin-bottom: 5px;  padding-right: 25px;" :style="[ifAdded(currentItem) ? {color: '#00bc8c !important'} : '']" :class="{'checked':ifAdded(currentItem)}" class="gc-button btn">
                        ADDED <span style="font-weight: 600; float: none;">{{ifAdded(currentItem)}} </span><span style="color: #00bc8c;" class="icon icon-check"></span>
                    </button>
                    <!-- ADD + -->
                    <button v-if="ifAdded(this.currentItem) && hasEmptySlots(this.currentItem, getBuild) == true"  @click="addToBuild(currentItem), addToMenu(currentItem), getPrice()" style="width: 17%; margin-left: 3%; margin-bottom: 5px;" class="gc-button btn">
                        <span style="padding-left: 0px !important; float: none; font-size: 20px;" class="icon icon-plus"></span>
                    </button>
                    <button v-if="ifAdded(this.currentItem) && hasEmptySlots(this.currentItem, getBuild) == false" style="width: 17%; margin-left: 3%; margin-bottom: 5px;" class="gc-button disabled btn">
                        <span style="padding-left: 0px !important; float: none; font-size: 20px;" class="icon icon-plus"></span>
                    </button>
                    <!-- REMOVE -->
                    <button v-if="ifAdded(this.currentItem)" @click="rmFromBuild({item: currentItem, id: undefined}), rmFromMenu({item: currentItem, id: undefined}), getPrice()" style="width: 80%; margin-bottom: 5px; padding-right: 25px;" class="gc-button btn">
                        REMOVE<span style="color: #e64759" class="icon icon-circle-with-cross delete-form-partslist" ></span>
                    </button>
                    <button v-if="ifAdded(this.currentItem)"  @click="rmFromBuild({item: currentItem, id: currentItem.id}), rmFromMenu({item: currentItem, id: currentItem.id}), getPrice()" style="width: 17%; margin-left: 3%; margin-bottom: 5px;" class="gc-button btn">
                        <span style="padding-left: 0px !important; float: none; font-size: 20px;" class="icon icon-minus"></span>
                    </button>
                </div>
                <!-- ELSE -->
                <div v-else>
                    <!-- <button v-if="ifAdded(this.currentItem)" style="width: 100%; margin-bottom: 5px;  padding-right: 25px;" :style="[ifAdded(currentItem) ? {color: '#00bc8c !important'} : '']" :class="{'checked':ifAdded(currentItem)}" class="gc-button btn">
                    SELECTED<span style="color: #00bc8c !important;" class="icon icon-check" ></span>
                    </button> -->
                    <button v-if="ifAdded(this.currentItem)"  style="width: 100%; margin-bottom: 5px; padding-right: 25px;"  @click="rmFromBuild({item: currentItem, id: undefined}), rmFromMenu({item: currentItem, id: undefined}), getPrice()" :class="{'remove':ifAdded(currentItem)}" class="gc-button btn">
                        REMOVE<span style="color: #e64759" class="icon icon-circle-with-cross delete-form-partslist" ></span>
                    </button>
                </div>
                <button style="width: 100%; text-transform:none; margin-bottom: 5px; padding-right: 6px;" class="gc-button btn cmpr-btn amzn-button" >
                    <!-- <a :href="'https://amazon.com/dp/'+ this.currentItem.asin+ this.amazon_ref" target="_blank"><span class="icon icon-shopping-cart"></span> <div style="display: inline-block;margin-top: 0px;">Buy On Amazon.com</div> </a> -->
                    <a :href="this.currentItem.amzn_link" target="_blank"><span class="icon icon-shopping-cart"></span> <div style="display: inline-block;margin-top: 0px;">Buy On Amazon.com</div> </a>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { Carousel3d, Slide }    from 'vue-carousel-3d'
import { mapActions }           from 'vuex'
import { mapGetters }           from 'vuex'
import { EventBus }             from '../../eventBus'
import VueSpeedometer           from "vue-speedometer"
import store                    from '../../store'
import {AMAZON_REF}             from '../../config'
import { functions }            from "../../functions.js"
export default {
    name: "Slider",
    components: {
        Carousel3d,
        Slide,
        VueSpeedometer,
    },
    props: ['items'],
    watch: { 
        currentItem: function(newVal) { // watch it
            if(this.firstLoad == true){
                this.priceFrom = 1
                this.priceTo = parseFloat(newVal.amzn_price)
                this.firstLoad = false
            }
            else {
                this.priceFrom = this.$refs.animatedNumber.to
                this.priceTo = parseFloat(newVal.amzn_price)
                this.updatePrice(this.priceFrom, this.priceTo)
                this.startAnimate()
            }               
        },
        items:  function(){
            console.log("WATCH ITEMS")
            this.autoChoose(this.computedCurrentIndex)
        },
        itemsLength: function(){
            this.autoChoose(this.computedCurrentIndex)
            this.refreshSlider()
        },
        computedCurrentIndex: function(newIndex){
            this.autoChoose(newIndex)
        }
    },
    data() {
        return {
            priceFrom: '',
            sliderRefresh: 0,
            firstLoad: true,
            priceTo: '',
            amazon_ref: AMAZON_REF,
            perf: 0,
            url_id: this.$route.query.id || undefined,
            isMounted: false,
            enlargeClicked: false,
            currentItem: '',
            addImg: {
                sample: require('../../assets/img/add-icon.png')
            },
            currentIndex: "not assigned",
            menuItem: null,
            slides: null,
            parentComponent: 'not yet assigned',
            index: Number(),
            welcomedList: {
                'Generation':           'Generation',
                'Integrated_Graphics':  'Int. Graphics',
                'Capacity':             'Capacity',
                'Cache_Memory':         'Cache Memory',
                'RAM_Type':             'RAM_Type',
                'RAM_Speed':            'RAM_Speed',
                'Number_of_Sticks':     'Sticks',
                'Disk_Type':            'Type',
                'size':                 'Size',
                'data_transfer_rate':   'Speed',
                'memory_clock_speed':   'Memory Clock',
                'graphics_interface':   'Interface',
                'connections':          'Connectors',
                'VR':                   'VR Support',
                'WiFi':                 "WiFi",
                'M_2_Slot':             'M.2_Slot',
                'm_2':                  'M.2',
                'wattage':              'Wattage',
                'energy_rating':        'Energy Rating',
                'tempered_glass':       'Tempered Glass',
                'color':                'Colors',
                'tdp':                  'TDP',
            },
        }
    },
    computed: {
        ...mapGetters([
            'allMenuOptions',
            'getCompatTable',
            'getBuildTDP',
            'getBuild'
        ]),
        itemsLength(){
            if(this.items){
                return this.items.length
            }
            return 0
        },
        computedCurrentIndex(){
            while (!this.slides){
                return 0
            }
            var ind = 0
            this.slides.map((slide) => {
                if(slide.isCurrent == true) {
                    return ind = slide.index
                }
            })
            return ind
        },
    },
    methods: {
        ...mapActions([
            'addToBuild',
            'rmFromBuild',
            'rmFromMenu',
            'addToMenu',
            'setStartIndex',  
            'getPrice',
            'setItems',
            'isCompatible'
        ]),
        getIdByIndex(index){
            if(this.items){
                return this.items[index].id
            }
        },
        loadSlides(){
            this.slides = this.$refs.slides
        },
        currentSlide(){
            console.log(this.slides)
            console.log(this.computedCurrentIndex)
        },
        refreshSlider(id){
            if( (this.$route.query.id && parseInt(this.$route.query.id) !== id)){
                this.$router.push({query: { id: id }})
            }
            this.sliderRefresh++
        },
        cents:              (num)                                       => functions.cents(num),
        getItemValue:       ({item, field})                             => functions.getItemValue({item, field}),
        checkPartCompat:    ({compatTable, type, asin})                 => functions.checkPartCompat({compatTable, type, asin}),
        checkCompatTable:   (type, option, build, item, compatTable)    => functions.checkCompatTable(type, option, build, item, compatTable),
        formatter: function (num) {
            return parseInt(num)
        },
        updatePrice(from, to) {
            this.$refs.animatedNumber.reset(from, to)
            this.$refs.animatedNumberCents.reset(0, this.cents(to))
        },
        startAnimate: function () {
            this.$refs.animatedNumber.start()
            this.$refs.animatedNumberCents.start()
        },
        getMaxMem({cpu, mb}){
            if(cpu && mb){
                if(parseInt(cpu.specs.Max_Memory_Size) <= parseInt(mb.specs.Max_Memory_Size)){
                    return cpu.specs.Max_Memory_Size
                }
                else return mb.specs.Max_Memory_Size
            }
            else if(cpu){
                return cpu.specs.Max_Memory_Size
            }
            else if(mb){
                return mb.specs.Max_Memory_Size
            }
            else return 
        },
        getMainImgUrl(imgUrl){
            var imgUrlArray = JSON.parse(imgUrl)
            if(typeof(imgUrlArray[0]) == 'string' && imgUrlArray[0].includes('a href')){
                return imgUrlArray[1]
            }
            console.log('type of img ', typeof(imgUrlArray[0]))
            return imgUrlArray[0]
        },
        hasEmptySlots(item, build){
            var type = item.type
            // RAM
            var mb
            if(type == 'ram'){
                var sticksTotal = 0
                var limit = 9
                var ram = build[2].contents
                mb = build[1].contents
                if(ram && ram.length > 0){
                    ram.map((item) => {
                    if(item.compat.number_of_items){
                        var sticks = parseInt(item.compat.number_of_items)
                        sticksTotal += sticks
                    }
                    })
                }
                if(mb && mb.compat.ram_slots){
                limit = parseInt(mb.compat.ram_slots)
                }
                if(sticksTotal >= limit){
                    return false
                }
                else {
                return true
                }
            }
            // STORAGE
            if(type == 'storage'){
                var occupiedSata = 0
                var occupiedM2 = 0
                var maxSata =  9
                var maxM2 =  9
                mb = build[1].contents
                var storage = build[3].contents
                // Setting max ports
                if(mb && mb !==null){
                if(parseInt(mb.compat.M_2_Slot) >0){
                    maxM2 = parseInt(mb.compat.M_2_Slot)
                }
                if(parseInt(mb.compat.sata_slots) >0){
                    maxSata = parseInt(mb.compat.sata_slots)
                }
                }
                // Counting occupied ports
                if(storage && storage.length > 0){
                storage.map((existingItem) => {
                    var size = existingItem.compat.size
                    // IF STORAGE IS SATA
                    if(!size.toLowerCase().includes('m.2')){
                    occupiedSata++
                    }
                    // IF STORAGE IS M.2
                    if(size.toLowerCase().includes('m.2')){
                    occupiedM2++
                    }
                })
                }
                // If no more free sata slots
                if(!item.compat.size.toLowerCase().includes('m.2')){
                if(occupiedSata >= maxSata){
                    return false
                }
                }
                // If no more free m.2 slots
                if(item.compat.size.toLowerCase().includes('m.2')){
                if(occupiedM2 >= maxM2){
                    return false
                }
                }
                return true
            }
            //GPU
            if(type == 'gpu' || type == 'graphics'){
                var slotsTotal = 0
                var max =  9
                var gpu = build[4].contents
                mb = build[1].contents
                if(mb && mb.compat.pci_e_x16){
                max = parseInt(mb.compat.pci_e_x16)
                }
                if(gpu && gpu.length > 0){
                gpu.map(() => {
                    slotsTotal += 1
                })
                }
                if(slotsTotal >= max){
                return false
                }
                else {
                return true
                }
            }
            else {
                return true
            }
            },
        getCompatibility({item, withType, option}){
            return store.dispatch('isCompatible', {item: item, withType: withType, option: option})
            .then((res) => {return res})
        },
        refreshPrice(){
            console.log(this.$refs['animatedNumber'])
        }, 
        getStartIndex(){
            var startIndex = this.computedCurrentIndex
            if(!this.$route.query.id){
                return startIndex
            }
            else {
                if(this.$route.query.id){
                    this.items.map((item, index) => {
                        if(item.id && item.id == this.url_id){
                            startIndex = index
                        }
                        if(typeof(item) == 'object' && item.length >0){
                            for(var i = 0; i < item.length; i++){
                                if(item[i].id){
                                    console.log('item has id ', item[i].id)
                                    if(item[i].id == this.url_id){
                                        startIndex =  index
                                    }
                                }
                            }
                        }
                    })
                    return startIndex
                }
                else {
                    return startIndex
                }
            } 
        },
        autoChoose(index){
            setTimeout(() => {
                if(this.items){
                    for (var i = 0; i < this.items.length; i++){
                        this.items[i].chosen = false   
                    }
                    if(this.currentItem !== this.items[index] || this.currentItem.chosen!==true){
                        console.log('setting current item')
                        this.items[index].chosen = true;
                        this.setStartIndex(index)
                        this.currentItem = this.items[index];
                    }
                    if((this.$route.query.id && !this.$route.query.redir && parseInt(this.$route.query.id) !== this.getIdByIndex(index)) || !this.$route.query.id){
                        this.$router.push({query: { id: this.getIdByIndex(index) }})
                    }
                    if(this.$route.query.redir){
                        let query = Object.assign({}, this.$route.query);
                        delete query.redir;
                        this.$router.replace({ query });
                    }
                    console.log("autochoose applied, item chosen: ", this.items[index])
                }
            }, 1)
        },
        getListBullets(item){
            var specsList = {}
            for (var spec in item.specs){
                if(item.specs[spec] !=='N/A' && Object.keys(this.welcomedList).includes(spec)){
                specsList[this.welcomedList[spec].split('_').join(' ')] = item.specs[spec]
                }
            }
            for (var compat in item.compat){
                if(item.compat[compat] !=='N/A' && Object.keys(this.welcomedList).includes(compat)){
                specsList[this.welcomedList[compat].split('_').join(' ')] = item.compat[compat]
                }
            }
            return specsList
        },
        unset(){
            this.menuItem = null
        },
        enlarge(item){
            EventBus.$emit('enlarge', item)
        },
        ifAdded(item){
            var type = ''
            if(item && item.type){
                if(item.type == "gpu"){
                    type = 'graphics'
                }
                else {
                    type = item.type
                }
            }
            if(this.getMenuOptions() && this.getMenuOptions()[type] && this.getMenuOptions()[type].item.contents && (type == 'storage' || type == 'ram' || type == 'graphics' || type == 'gpu')){
                if(typeof(this.getMenuOptions()[type].item.contents == 'object') && this.getMenuOptions()[type].item.contents.length > 0){
                    var response = false
                    var seen = []
                for (var i = 0; i < this.getMenuOptions()[type].item.contents.length; i++){
                    if (this.getMenuOptions()[type].item.contents[i].id == item.id){
                        seen.push(item.id)
                    }
                    else{
                        response = false
                    }
                }
                if(seen.length > 0){
                    return seen.length
                }
                return response
                }
            }
            else if(this.getMenuOptions() && this.getMenuOptions()[type] && this.getMenuOptions()[type].item.contents){
                if(item.id == this.getMenuOptions()[type].item.contents.id){
                return true
                }
            }
            return false
        },
        getMenuOptions(){
            return this.allMenuOptions
        },
        getMainImg(imgUrl){
            return imgUrl
        },        
    },
    updated(){
        //Updating slides variable
        if(this.currentItem.performance && this.currentItem.performance >1){
            this.perf = this.currentItem.performance
        }
    },
    beforeMount(){
        EventBus.$on('goSlide', (index) => {
            console.log('received start slide index ', index)
            this.index = index
        })
    },
    mounted() {
        document.addEventListener("keydown", (event) => {
            if(event.keyCode == 39 && this.$refs.slider){
                this.$refs.slider.goNext()
            }
            else if (event.keyCode == 37 && this.$refs.slider){
                this.$refs.slider.goPrev()
            }
        });
        EventBus.$on('added', (item) => {
            this.menuItem = item
        });
        EventBus.$on('unset', () => {
            console.log('received unset')
            this.unset();
        });
        this.isMounted = true;
        if((!this.$route.query.id)){
            this.$router.push({query: { id: this.items[0].id }})
        }
        this.autoChoose(this.computedCurrentIndex)
    },
}
</script>
<style>
@import '../../assets/css/slider.css';
.amzn-button {
    transition: 0.2s !important;
    position: relative;
}
.big-title::-webkit-scrollbar {
  display: none;
}
.big-title {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
  color: #CFD2DA; 
  display: inline-block; 
  white-space: nowrap; 
  overflow-x: scroll;
  letter-spacing: 2px; 
  margin-bottom: 0px; 
  width: 100%; 
}
.big-title::-webkit-scrollbar{
    display: none !important;
}
.amzn-button a {
    position: absolute;
    right: 0px;
    left: 0px;
    top: 0px;
    bottom: 0px;
    padding-top: 4px;
    padding-left: 5px;
}
::-webkit-scrollbar { 
    display:unset !important;    
}
.amzn-button:hover a {
    color: white;
}
.amzn-button:hover{
    background-color: #1997c6 !important;
    transition: 0.2s !important;
}
.amzn-button:hover span{
    color: #cfd2da !important;
    transition: 0.2s !important;
}
.infographics {
    min-width: 260px !important;
}
.warn {
    color: #E1d420 !important;
}
</style>